import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import type { PreCompraFormValues } from '../../components/pre-compras/pre-compra.schema';
import PreCompraForm from '../../components/pre-compras/PreCompraForm';
import { useCorralesStore } from '../../stores/corrales/corrales.store';
import type { PreCompraBusqueda } from '../../stores/pre-compras/pre-compra';
import {
  usePreComprasStore,
  type RegistrarPreCompraRequest
} from '../../stores/pre-compras/pre-compra.store';
import { useTiposGanadoStore } from '../../stores/tipos-ganado/tipos-ganado.store';
import { useZonasStore } from '../../stores/zonas/zonas.store';

const RegistrarPreCompra = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const {
    current: precompra,
    nueva,
    registrar,
    historialSiiniga,
    historialTemporal,
    cargarHistorialSiiniga,
    cargarHistorialTemporal
  } = usePreComprasStore();
  const { actives: tiposGanado, cargarActivos: cargarTiposGanado } = useTiposGanadoStore();
  const { actives: corrales, cargarActivos: cargarCorrales } = useCorralesStore();
  const { actives: zonas, cargarActivas: cargarZonas } = useZonasStore();

  useEffect(() => {
    nueva();
    cargarTiposGanado();
    cargarCorrales();
    cargarZonas();
  }, []);

  const handleSave = async (values: PreCompraFormValues) => {
    const request: RegistrarPreCompraRequest = {
      fecha: values.fecha.toDate(),
      idCorral: values.idCorral,
      idZona: values.idZona!,
      idPersonaEntrega: values.idPersonaEntrega,
      idPersonaRecibe: values.idPersonaRecibe,
      idPersonaVende: values.idPersonaVende,
      totalAnimales: values.totalAnimales,
      referencia: values.referencia,
      partidas: values.animales.map((a) => ({
        areteSiiniga: a.areteSiiniga,
        areteTemporal: a.areteTemporal,
        tienePapeles: a.tienePapeles,
        reemo: a.reemo,
        idTipoGanado: a.idTipoGanado,
        kgCompra: a.kgCompra,
        kgLlegada: a.kgLlegada
      }))
    };
    await registrar(request);
    await nueva();
    return true;
  };

  const handlePreCompraSelect = (precompra: PreCompraBusqueda) => {
    const index = pathname.lastIndexOf('/');
    const basePath = pathname.substring(0, index);
    navigate(`${basePath}/editar/${precompra.folioInterno}`);
  };

  return (
    <PreCompraForm
      esAgregar={true}
      precompra={precompra}
      tiposGanado={tiposGanado}
      corrales={corrales}
      zonas={zonas}
      historialSiiniga={historialSiiniga}
      historialTemporal={historialTemporal}
      cargarHistorialSiiniga={cargarHistorialSiiniga}
      cargarHistorialTemporal={cargarHistorialTemporal}
      onAdd={nueva}
      onSave={handleSave}
      onPreCompraSelected={handlePreCompraSelect}
    />
  );
};

export default RegistrarPreCompra;
